import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import * as Mui from '@material-ui/core';
import * as MuiIcons from '@material-ui/icons';
import * as pdvActions from '~/store/modules/pdv/pdv-actions';
import { Header } from './styles';
import QuantidadeInput from '~/components/QuantidadeInput';
import { useTheme } from '@material-ui/core';

const ModalEditarQuantidade = ({ open, onClose, data: { produto, itemVenda, quantidade } }) => {
  const dispatch = useDispatch();
  const theme = useTheme();

  const quantidadeRef = useRef();
  const [quantidadeAtualizada, setQuantidadeAtualizada] = useState(quantidade);

  const changeQuantidade = quantidade => {
    setQuantidadeAtualizada(quantidade);
  };

  const handleKeyPress = ev => {
    if (ev.key === 'Enter') {
      ev.preventDefault();
      handleSubmit();
    }
  };

  const handleSubmit = async () => {
    dispatch(
      pdvActions.editarQuantidadeItemVendido({ ...itemVenda, quantidadeAtualizada }, () => {
        if (onClose) {
          onClose();
        }
      })
    );

    return;
  };

  return (
    <>
      <Mui.Dialog
        open={open}
        onKeyDown={key => {
          if (key.code === 'Escape') {
            onClose();
          }
        }}
        PaperComponent={Mui.Paper}
        maxWidth={'sm'}
      >
        <Mui.DialogTitle>
          <Mui.AppBar color="primary" position="static">
            <Mui.Toolbar>
              <Mui.Box style={{ minWidth: 180 }}>
                <Mui.Typography variant="h5" style={{ textTransform: 'upperCase' }}>
                  Editar quantidade
                </Mui.Typography>
              </Mui.Box>
              <Mui.Box flexGrow={1} />

              <Mui.IconButton color="inherit" onClick={onClose} aria-label="close">
                <MuiIcons.Close />
              </Mui.IconButton>
            </Mui.Toolbar>
          </Mui.AppBar>

          <Mui.Grid item md={12}>
            <Header style={{
              background: theme.palette.background.darkest,
              color: theme.palette.text.secondary}}>
              <Mui.Box p={1}>
                <Mui.Typography variant="caption">Produto</Mui.Typography>
                <Mui.Typography variant="h4">
                  {produto?.codigo} {' - '}
                  {itemVenda?.produtoDescricao || produto?.descricao}
                </Mui.Typography>
              </Mui.Box>
            </Header>
          </Mui.Grid>
        </Mui.DialogTitle>
        <Mui.DialogContent dividers style={{ padding: 16 }}>
          <Mui.Grid container spacing={2}>
            <Mui.Grid item md={6}>
              <Mui.Typography variant="p">Quantidade:</Mui.Typography>
              <Mui.TextField
                id="quantidade"
                type="number"
                variant="outlined"
                fullWidth
                autoFocus
                disabled={true}
                InputProps={{
                  style: {
                    height: 44
                  }
                }}
                value={quantidade ?? 1}
              />
            </Mui.Grid>
            <Mui.Grid item md={6}>
              <Mui.Typography variant="p">Quantidade atualizada:</Mui.Typography>
              <QuantidadeInput
                ref={quantidadeRef}
                produto={produto}
                value={quantidadeAtualizada}
                onChange={changeQuantidade}
                onKeyPress={handleKeyPress}
                autoFocus
                required
              />
            </Mui.Grid>
          </Mui.Grid>
        </Mui.DialogContent>
        <Mui.DialogActions>
          <Mui.Button
            variant="contained"
            className="button-success"
            startIcon={<MuiIcons.CheckCircle />}
            onClick={handleSubmit}
          >
            Confirmar
          </Mui.Button>
          <Mui.Button startIcon={<MuiIcons.Close />} onClick={onClose}>
            Cancelar (ESC)
          </Mui.Button>
        </Mui.DialogActions>
      </Mui.Dialog>
    </>
  );
};

export default ModalEditarQuantidade;
